module.exports = __webpack_public_path__ + "static/media/casino_home.d0f72435.png";